import './AVIActionButton.scss';

import React, { Component } from 'react';

import PropTypes from 'prop-types';

export class AVIActionButton extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func
  };

  static defaultProps = {
    onClick: d => console.debug('No click event implemented')
  }

  render () {
    const { label, onClick } = this.props;
    return (
      <button className='action-button' type='button' onClick={onClick}>
        {label}
      </button>
    );
  }
}
